{
 "achlys": [
  557,
  720
 ],
 "adrasteia": [
  451,
  720
 ],
 "aergia": [
  529,
  720
 ],
 "akosmia": [
  344,
  720
 ],
 "akrasia": [
  379,
  720
 ],
 "amathia": [
  427,
  720
 ],
 "amechania": [
  429,
  720
 ],
 "apate": [
  335,
  720
 ],
 "aporia": [
  233,
  720
 ],
 "ate": [
  346,
  720
 ],
 "atlas": [
  407,
  720
 ],
 "chaos": [
  318,
  720
 ],
 "dysastria": [
  410,
  720
 ],
 "dysnomia": [
  290,
  720
 ],
 "homados": [
  347,
  720
 ],
 "kakia": [
  456,
  720
 ],
 "koalemos": [
  278,
  720
 ],
 "lethe": [
  357,
  720
 ],
 "oistros": [
  307,
  720
 ],
 "oizys": [
  382,
  720
 ],
 "oknos": [
  503,
  720
 ],
 "phthisis": [
  397,
  720
 ],
 "plane": [
  456,
  720
 ]
}
